import { createScheduled, debounce } from '@solid-primitives/scheduled';
import { Ref } from '@solid-primitives/refs';
import { ParentProps, createSignal, onCleanup, createRoot, onMount, createEffect, createMemo } from 'solid-js';
import { useIsActive } from './Active';

const [els, setEls] = createSignal<Element[]>([]);
/**
 * @param el
 * @param unshift 是否往前面插入
 */
export function setActiveElement(el: Element, unshift: boolean = false) {
  onMount(() => {
    setEls((pre) => {
      return unshift ? [el, ...pre] : [...pre, el];
    });
  });
  onCleanup(() => {
    setEls((pre) => {
      // console.log('clear', el, pre, pre.filter((it) => it !== el));
      return pre.filter((it) => it !== el);
    });
  });
}
createRoot(() => {
  const scheduled = createScheduled((fn) => debounce(fn, 160));

  const enable = createMemo<boolean>((pre) => {
    const enable = els().length > 0;
    return scheduled() ? enable : pre;
  }, false);

  // createEffect(() => {
  //   document.body.classList.toggle('lock-scroll', enable());
  // });
});

/** 锁定滚动，当子元素存在的时候将锁定全局的滚动 */
export function BodyLock(props: ParentProps<{ disabled?: boolean }>) {
  let el!: HTMLDivElement;
  const active = useIsActive();

  createEffect(() => {
    if (!props.disabled && active() && el) {
      setActiveElement(el);
    }
  });

  return <Ref ref={el}>{props.children}</Ref>;
}
